export class RequestShellDevice {
  constructor(id, name, user) {
    this.ID = id;
    this.NAME = name;
    this.USER = user;
  }
}
